/**
 * Entrance motion for a series.
 *
 * Elements arrive in reading order, 35ms apart, and the whole thing finishes
 * inside half a second — longer and the reader is waiting to read a number,
 * which is the opposite of the point.
 *
 * Returns `className` and `style` rather than a wrapper component so a caller
 * can spread it onto whatever element it was already rendering; wrapping a
 * grid cell or a flex child in an extra div is what breaks these layouts.
 */

/** Milliseconds between one element's entrance and the next. */
export const STAGGER_MS = 35;

const DIRECTION_CLASS = Object.freeze({
  bottom: 'wg-enter-rise',
  left: 'wg-enter-slide',
  scale: 'wg-enter-pop',
  fade: 'wg-enter-fade',
});

/**
 * @param {number} index Position in the series.
 * @param {'bottom'|'left'|'scale'|'fade'} [from='bottom'] Which way it arrives.
 * @returns {{ className: string, style: { animationDelay: string } }}
 */
export const enterAt = (index, from = 'bottom') => ({
  className: DIRECTION_CLASS[from] ?? DIRECTION_CLASS.bottom,
  style: { animationDelay: `${index * STAGGER_MS}ms` },
});

export default enterAt;
